import { Calendar, ShoppingBag, Video, Image, Package2, Home, Share2, MessageSquare } from 'lucide-react';

export const MINI_APP_ICONS = {
  products: Package2,
  calendar: Calendar,
  services: ShoppingBag,
  videos: Video,
  gallery: Image,
  realestate: Home,
  social: Share2,
  'order-tracking': MessageSquare
} as const;

export type MiniAppId = keyof typeof MINI_APP_ICONS;

export const DEFAULT_MINI_APPS = [
  {
    id: 'products',
    title: 'Mini App Products',
    label: 'Product search',
    enabled: true,
    icon: Package2
  },
  {
    id: 'calendar',
    title: 'Mini App Calendly',
    label: 'Book a demo',
    enabled: true,
    icon: Calendar
  },
  {
    id: 'services',
    title: 'Mini App Services',
    label: 'Our services',
    enabled: true,
    icon: ShoppingBag
  },
  {
    id: 'videos',
    title: 'Mini App Videos',
    label: 'Gallery videos',
    enabled: true,
    icon: Video
  },
  {
    id: 'gallery',
    title: 'Mini App Photos',
    label: 'Gallery photos',
    enabled: true,
    icon: Image
  },
  {
    id: 'realestate',
    title: 'Mini App Real Estate',
    label: 'Our properties',
    enabled: true,
    icon: Home
  },
  {
    id: 'social',
    title: 'Mini App Social Media',
    label: 'Social Media',
    enabled: true,
    icon: Share2
  },
  {
    id: 'order-tracking',
    title: 'Mini App Order Tracking',
    label: 'Track my order',
    enabled: true,
    icon: MessageSquare
  }
];